import BillingPositionCategoriesAbstractEditorController from './abstract-editor-controller';

export default class BillingPositionCategoriesCreateController extends BillingPositionCategoriesAbstractEditorController {
    $onInit() {
        super.$onInit();

        this.loading = false;
    }

    doSave() {
        this.api
            .post(`billing/positions/categories`, this.model)
            .then(() => {
                this.alert.success(
                    this.translate.instant('general.alerts.create_success.title'),
                    this.translate.instant('general.alerts.create_success.content')
                )
                this.cancel();
            })
            .catch((res) => {
                this.alert.handle(res);
                this.submitting = false;
            })
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/position_categories/controllers/create-controller.js